import useGetAssessment from './useGetAssessment'
import useGetAdminAssessment from './useGetAdminAssessment'
import useGetAudioFile from './useGetAudioFile'

export default { useGetAssessment, useGetAdminAssessment, useGetAudioFile }